import React, { useState } from 'react'
import SVG from 'react-inlinesvg'
import { useTranslation } from 'react-i18next'
import { cn } from '../../utils/cn'

type Props = {
  setIsDialogOpen: React.Dispatch<React.SetStateAction<boolean | undefined>>
}

const MobileDeviceNotification = ({ setIsDialogOpen }: Props) => {
  const { t } = useTranslation()
  const [fadeOut, setFadeOut] = useState<boolean>(false)

  const onClose = () => {
    setFadeOut(true)
    setTimeout(() => {
      setIsDialogOpen(false)
      setFadeOut(false)
    }, 800)
  }

  return (
    <div className="relative z-[9] flex size-full items-center justify-center">
      <div id="layer" className="absolute left-0 top-0 size-full bg-black/[0.68]" />
      <div
        className={cn(
          'flex h-[238px] w-[395px] flex-col items-center justify-center rounded-[12px] bg-white',
          {
            'animate-[fade-out-y-10p_0.8s_ease_forwards]': fadeOut,
            'animate-[fade-in-y-10p_1.5s_ease_forwards]': !fadeOut,
          },
        )}
      >
        <button
          className="absolute right-[10px] top-[10px] float-right mr-[5px] mt-[5px] min-h-[26px] min-w-[36px] border-0 bg-white"
          onClick={onClose}
        >
          <SVG className="max-h-full max-w-full" src="/icons/x.svg" />
        </button>
        <div className="mt-[30px] h-[111px] w-[331px] text-center text-[18px] leading-[28px] tracking-[0.43px] text-black">
          {t('mobileDeviceNotification')}
        </div>
        <button
          className="h-[40px] w-[90px] rounded-[20px] border-0 bg-red text-[18px] tracking-[0.43px] text-white"
          onClick={onClose}
        >
          OK
        </button>
      </div>
    </div>
  )
}

export default MobileDeviceNotification
